exports.default = {
  'membership_promotion': '會員推廣計劃',
  'page_under_development': '頁面正在緊鑼密鼓開發中，敬請期待！'
}
